import { useFetch } from "@/helpers/composables/useFetch";
import { route } from "ziggy-js";

export function useMetaConversionAPI () {

    const generateEventId = (): string => {
        return 'event-' + Date.now() + '-' + Math.random().toString(36).substring(2);
    };

    const getEventId = (): string => {
        return generateEventId();
    };

    const metaPageView = () => {
        const eventId = getEventId();
        
        if (typeof fbq !== 'undefined') {
            fbq('track', 'PageView', {}, { eventID: eventId });
        }
        useFetch(route("meta.event.page_view"), {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
            .post({
                event_id: eventId,
                url: window.location.href
            })
            .json();
    };

    const metaProductView = (payload) => {
        const eventId = getEventId();

        if (typeof fbq !== 'undefined') {
            fbq('track', 'ProductView', {
                product_id: payload.rothco_item_no,
                product_name: payload.item_name,
                product_price: payload.price,
            }, { eventID: eventId });
        }
        
        useFetch(route("meta.event.product_view"), {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
            .post({
                ...payload, 
                event_id: eventId,
                url: window.location.href
            })
            .json();     
    };

    const metaAddToCart = (list_items) => {

        const eventId = getEventId();

        if (typeof fbq !== 'undefined') {
            list_items.forEach(item => {
                fbq('track', 'AddToCart', {
                    product_name: item.variation.item.name,
                    product_id: item.variation.rothcoItem.rothco_item_no,
                    product_variant_id: item.variation.item_variation_id,
                    price: item.price,
                    quantity: item.quantity,
                    currency: "USD",
                }, { eventID: eventId });
            });
        }

        const list_item_ids = list_items?.map(item => item.list_item_id);
        useFetch(route("meta.event.add_to_cart"), {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                    
            })
            .post({ 
                list_item_ids: list_item_ids,
                event_id: eventId,
                url: window.location.href
            })
            .json();     
    };

    const metaPurchase = (payload) => {
        const eventId = `purchase_${payload.order_id}`;

        if (typeof fbq !== 'undefined') {
            const subtotal = payload.subtotal || 0;
            const shipping = payload.shipping || 0;
            const dropship = payload.dropship || 0;
            const sales_tax = payload.sales_tax || 0;
            const total = payload.total || 0;
            
            const contents = payload.items?.map(item => ({
                product_id: item.variation?.rothcoItem?.rothco_item_no,
                item_id: item.variation?.rothcoItem?.rothco_item_no,
                product_name: item.variation?.item?.name,
                item_variant: item.variation?.variation_text,
                quantity: item.quantity,
                item_price: item.price,
            })) || [];

            fbq('track', 'Purchase', {
                value: total,
                currency: 'USD',
                contents: contents,
                items: contents,
                num_items: contents.length,
                total: total,
                subtotal: subtotal,
                shipping: shipping,
                dropship: dropship,
            }, { eventID: eventId });
        }
    };

    return {
        metaPageView,
        metaProductView,
        metaAddToCart,
        metaPurchase
    };
}
